<template>
    <div class="signDocumentBg">
        <div class="signDocumentHeader">
            <div>签署</div>
            <div>简体中文</div>
        </div>
        <canvas class="canvas-front" id="signCanvas" disable-scroll v-if="showCan" @touchstart="touchstart"
            @touchmove="touchmove" @touchend="drawable = false" @touchcancel="drawable = true"
            :style="{ width: canvasWidth + 'px', height: canvasHeight + 'px' }"></canvas>

        <div class="btn-bar">
            <van-button round block type="info" @click="handleConfirm()">提交</van-button>
            <van-button round block type="info" @click="handleReset()">重置</van-button>
        </div>
    </div>
</template>

<script>
import { getUrlParams } from '@/utils/utils.js'
import { setStore, removeStore  } from '@/utils/utils';
import upServer from '@/api/upData.js'
import config from '@/config/config.js'

export default {
    name: "app",
    data() {
        return {
            drawable: false,
            showCan: true,
            submitting: false,
            windowWidth: 0,
            windowHeight: 0,
            canvasOffsetLeft: 0,
            canvasOffsetTop: 0,
            canvas: null,
            ratio: 1,
            token: '',
            key: ''
        };
    },
    computed: {
        canvasWidth() {
            return Math.max(this.windowWidth - 30, 200)
        },
        canvasHeight() {
            return Math.max(this.windowHeight - 130, 200)
        },
        landscape() {
            //  是否横屏
            return this.windowHeight > this.windowWidth
        }
    },
    watch: {
        landscape(val, oldVal) {
            //  监听屏幕横竖屏切换动作，若屏幕翻转则重新绘制画布
            this.init()
            setTimeout(() => {
                window.document.scrollTop = 0
            }, 500)
        }
    },
    created() {
        this.token = getUrlParams().token
        this.key = getUrlParams().key
        setStore('token', this.token)
        console.log(this.token)
    },
    mounted() {
        let that = this
        window.addEventListener('resize', function (e) {
            that.getWindowSize()
        });

        this.canvas = document.getElementById("signCanvas")
        this.context = this.canvas.getContext("2d")
        this.getWindowSize()
        this.init()
    },
    methods: {
        init() {
            this.resetCanvas()
            this.$nextTick(() => {
                this.canvasOffsetLeft = document.getElementById('signCanvas').offsetLeft
                this.canvasOffsetTop = document.getElementById('signCanvas').offsetTop
            })
        },
        touchstart({ touches }) {
            if (!this.submitting && touches.length === 1) {
                this.startRender(touches[0])
            }
        },
        touchmove(event) {
            let { touches } = event
            if (!this.submitting && touches.length === 1) {
                this.render(touches[0])
            }
            event.preventDefault()
        },
        //  获取画布比例, 修改画布尺寸
        getCanvasRatio() {
            const devicePixelRatio = window.devicePixelRatio || 1
            const backingStoreRatio = this.canvas.webkitBackingStorePixelRatio || 1
            const ratio = devicePixelRatio / backingStoreRatio
            this.ratio = ratio
            this.canvas.width = this.canvasWidth * ratio
            this.canvas.height = this.canvasHeight * ratio
            this.context.scale(ratio, ratio)
        },
        //  获取窗口尺寸
        getWindowSize() {
            this.windowWidth = document.getElementsByTagName('body')[0].offsetWidth
            this.windowHeight = document.getElementsByTagName('body')[0].offsetHeight
        },
        // 手指按下，准备绘制
        startRender(pos) {
            if (this.placeholder) {
                // 清空画布
                this.clear()
                this.placeholder = false
            }

            const ctx = this.context

            // 画笔设置
            ctx.strokeStyle = 'black'   // 线条颜色
            ctx.lineWidth = 4           // 线宽
            ctx.lineJoin = 'round'      // 拐角处平滑处理
            ctx.shadowBlur = 2          // 线条阴影
            ctx.shadowColor = 'gray'    // 线条阴影

            this.drawable = true

            this.startPos = {
                x: pos.clientX - this.canvasOffsetLeft,
                y: pos.clientY - this.canvasOffsetTop
            }
            const newPos = this.transformPos(this.startPos, { x: 0, y: 0 })

            ctx.moveTo(newPos.startX, newPos.startY);
        },
        // 绘制图形
        render({ clientX, clientY }) {
            if (this.drawable) {
                let x = clientX - this.canvasOffsetLeft
                let y = clientY - this.canvasOffsetTop
                const ctx = this.context
                const pos = this.transformPos(this.startPos, { x, y })
                ctx.lineTo(pos.startX, pos.startY)
                ctx.stroke()
                this.startPos = { x, y }
            }
        },
        // 坐标转换
        transformPos(start, target) {
            if (this.landscape) {
                return {
                    startX: start.y,
                    startY: this.canvasWidth - start.x,
                    targetX: target.y,
                    targetY: this.canvasWidth - target.x
                }
            }

            return {
                startX: start.x,
                startY: start.y,
                targetX: target.x,
                targetY: target.y
            }
        },
        // 变换画布
        transformCanvas() {
            if (this.landscape) {
                const ctx = this.context
                ctx.translate(this.canvasWidth, 0)
                ctx.rotate(Math.PI / 2);
            }
        },
        // 计算canvas的尺寸
        getCanvasSize() {
            if (this.landscape) {
                return {
                    width: this.canvasHeight,
                    height: this.canvasWidth
                }
            }
            return {
                width: this.canvasWidth,
                height: this.canvasHeight
            }
        },
        // 清空绘图区域
        clear() {
            let cxt = this.context
            cxt.fillStyle = "rgba(0, 0, 0, 0)";
            cxt.beginPath();
            cxt.fillRect(0, 0, this.canvas.width, this.canvas.height)
            cxt.closePath();
            cxt.clearRect(0, 0, this.canvas.width, this.canvas.height)
        },
        // 重制画布
        resetCanvas() {
            this.clear()
            this.getCanvasRatio()
            this.transformCanvas()
            this.drawPlaceholder()
        },
        // 绘制 placeholder
        drawPlaceholder() {
            const canvasSize = this.getCanvasSize()
            const ctx = this.context
            const margin = 20
            const fontSize = 40
            const font = '40px Arial'
            const imgSize = 38
            const color = '#999999'
            const text = '签名区'

            let img = new Image()
            img.src = require('./img/pen.png')
            img.onload = function () {
                ctx.drawImage(img, x, y, imgSize, imgSize)
            }

            const width = fontSize * 3 + margin + imgSize
            let x = (canvasSize.width - width) / 2
            let y = (canvasSize.height - imgSize) / 2
            ctx.font = font
            ctx.fillStyle = color
            ctx.textBaseline = 'top'
            ctx.fillText(text, x + imgSize + margin, (canvasSize.height - fontSize) / 2)
            this.placeholder = true
        },
        // 重签
        handleReset() {
            if (!this.submitting) {
                this.resetCanvas()
            }
        },
        // 签名确认
        handleConfirm() {
            if (this.placeholder) {
                return this.$toast('请手写签名进行确认')
            }
            if (!this.submitting) {
                this.submitting = true
                this.submit()
            }
        },
        // 签名提交处理
        submit() {

            //  canvas转换文件
            let file = this.canvasToFile(this.canvas.toDataURL())
            // let formData = new FormData()
            // formData.append("file", file)
            // formData.append("key", this.key)
            // const opts = { formData }
            this.selfSubmit(file)
        },
        selfSubmit(opts = {}) {
            return this.uploadImg(opts)
        },
        uploadImg(file) {
            this.$toast.loading({
                message: '签名生成中…',
                forbidClick: true,
            });
            upServer({url: config.baseURL + '/user/uploadSignature'}, {
                file,
                param: {key: this.key}
            }).then(res => {
                console.log(res)
                if (res.data.code == '200') {
                    this.$toast.clear();
                    this.submitting = false
                    this.$toast.success('签名已成功提交')
                    this.resetCanvas()
                    removeStore('token')
                    this.$router.push({ path: '/' });
                } else {
                    this.$toast(res.data.message)
                }
            })
        },
        canvasToFile(base64Data) {
            // base64数据格式:
            let type, onlyData
            if (/^data:(\w+\/\w+);base64,(.+)/.test(base64Data)) {
                type = RegExp.$1
                onlyData = RegExp.$2
            } else {
                console.error(`toBlobData(data), "${base64Data}" is not base64 data!`)
                return null
            }

            let data = window.atob(onlyData)
            let ia = new Uint8Array(data.length)
            for (let i = 0; i < data.length; i++) {
                ia[i] = data.charCodeAt(i)
            }
            let blob = new Blob([ia], { type: type })
            return new window.File([blob], `${this.userId}-${this.documentId}.png`)
        }
    },
};
</script>

<style lang="scss">
.signDocumentBg {
    padding: 15px;
    min-height: 100%;
    box-sizing: border-box;
    height: fit-content;
    overflow: hidden;

    .signDocumentHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .canvas-front {
        position: relative;
        z-index: 10;
        background-color: #e5e5e5;
        border: 1px solid #e2e2e2;
        border-radius: 4px;
        box-sizing: border-box;
        margin-top: 10px;
    }

    .btn-bar {
        line-height: 60px;
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .van-button {
            width: 100px;
            margin-left: 10px;
        }
    }
}
</style>